<div class="action-dropdown-menu">
  <ftr-dropdown-menu
    (isOpen)="setOpenState($event)"
    [ariaLabel]="ariaLabel"
    [menuItems]="menuItems"
    [routerLinkActiveExact]="routerLinkActiveExact"
    [openerTemplate]="dropdownOpenerTemplate"
  >
  </ftr-dropdown-menu>
  <ng-template #dropdownOpenerTemplate>
    <div (click)="toggle()" class="action-dropdown-menu-opener" aria-label="Settings">
      <button
        ftrButton
        [displayType]="buttonDisplayType.Icon"
        [size]="buttonSize.Large"
        [attr.aria-label]="ariaLabel"
        class="action-dropdown-menu-opener__button"
        [class.dropdown-open]="isDropdownOpen"
      >
        <ftr-icon icon="Settings" size="Large"></ftr-icon>
        <ftr-icon icon="KeyboardArrowDown" size="Large"></ftr-icon>
      </button>
    </div>
  </ng-template>
</div>
